/**
 * @generated SignedSource<<f6b50e0d763577ecdcf6721a554b28a8>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "commentsCount"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "commentsCursor"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "contributionId"
},
v3 = [
  {
    "kind": "Variable",
    "name": "contributionId",
    "variableName": "contributionId"
  }
],
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isFromAdminUser",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "votesDisplayAuthorized",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "votesSubmissionAuthorized",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "commentsDisplayAuthorized",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "requiresModeration",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "submitComment",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v14 = {
  "kind": "TypeDiscriminator",
  "abstractKey": "__isAnswerBase"
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "content",
  "storageKey": null
},
v16 = [
  (v15/*: any*/)
],
v17 = {
  "kind": "InlineFragment",
  "selections": (v16/*: any*/),
  "type": "AnswerString",
  "abstractKey": null
},
v18 = {
  "kind": "InlineFragment",
  "selections": (v16/*: any*/),
  "type": "AnswerText",
  "abstractKey": null
},
v19 = {
  "kind": "InlineFragment",
  "selections": (v16/*: any*/),
  "type": "AnswerRichText",
  "abstractKey": null
},
v20 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "urls",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Attachment",
      "kind": "LinkedField",
      "name": "sources",
      "plural": true,
      "selections": [
        (v5/*: any*/),
        (v12/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "url",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "AnswerFile",
  "abstractKey": null
},
v21 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "formattedValues",
  "storageKey": null
},
v22 = {
  "kind": "InlineFragment",
  "selections": [
    (v21/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "other",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "otherValue",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "formField",
      "plural": false,
      "selections": [
        (v13/*: any*/),
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "otherFieldLabel",
              "storageKey": null
            }
          ],
          "type": "FormFieldCheckBoxes",
          "abstractKey": null
        },
        (v5/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "type": "AnswerCheckBoxes",
  "abstractKey": null
},
v23 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "value",
  "storageKey": null
},
v24 = {
  "alias": null,
  "args": null,
  "concreteType": null,
  "kind": "LinkedField",
  "name": "options",
  "plural": true,
  "selections": [
    (v13/*: any*/),
    (v5/*: any*/),
    (v12/*: any*/)
  ],
  "storageKey": null
},
v25 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "AnswerWeightedOption",
      "kind": "LinkedField",
      "name": "dispatchedBudgetValues",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "optionId",
          "storageKey": null
        },
        (v23/*: any*/),
        (v5/*: any*/)
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "formField",
      "plural": false,
      "selections": [
        (v13/*: any*/),
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "maxBudgetPerOption",
              "storageKey": null
            },
            (v24/*: any*/)
          ],
          "type": "FormFieldBudgetDispatcher",
          "abstractKey": null
        },
        (v5/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "type": "AnswerBudgetDispatcher",
  "abstractKey": null
},
v26 = {
  "kind": "InlineFragment",
  "selections": [
    (v21/*: any*/)
  ],
  "type": "AnswerSortableList",
  "abstractKey": null
},
v27 = [
  (v5/*: any*/)
],
v28 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "label",
  "storageKey": null
},
v29 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "AnswerItemOption",
      "kind": "LinkedField",
      "name": "itemOptions",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "FormFieldItem",
          "kind": "LinkedField",
          "name": "item",
          "plural": false,
          "selections": (v27/*: any*/),
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "FormFieldOptionChoice",
          "kind": "LinkedField",
          "name": "option",
          "plural": false,
          "selections": (v27/*: any*/),
          "storageKey": null
        },
        (v5/*: any*/)
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "formField",
      "plural": false,
      "selections": [
        (v13/*: any*/),
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "FormFieldItem",
              "kind": "LinkedField",
              "name": "items",
              "plural": true,
              "selections": [
                (v5/*: any*/),
                (v28/*: any*/)
              ],
              "storageKey": null
            },
            (v24/*: any*/)
          ],
          "type": "FormFieldMatrix",
          "abstractKey": null
        },
        (v5/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "type": "AnswerMatrix",
  "abstractKey": null
},
v30 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "selectedThemeIds",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "formField",
      "plural": false,
      "selections": [
        (v13/*: any*/),
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "FormFieldThemeOption",
              "kind": "LinkedField",
              "name": "themes",
              "plural": true,
              "selections": [
                (v28/*: any*/),
                (v23/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "FormFieldThemeOption",
                  "kind": "LinkedField",
                  "name": "children",
                  "plural": true,
                  "selections": [
                    (v28/*: any*/),
                    (v23/*: any*/),
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "FormFieldThemeOption",
                      "kind": "LinkedField",
                      "name": "children",
                      "plural": true,
                      "selections": [
                        (v28/*: any*/),
                        (v23/*: any*/),
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "FormFieldThemeOption",
                          "kind": "LinkedField",
                          "name": "children",
                          "plural": true,
                          "selections": [
                            (v28/*: any*/),
                            (v23/*: any*/),
                            {
                              "alias": null,
                              "args": null,
                              "concreteType": "FormFieldThemeOption",
                              "kind": "LinkedField",
                              "name": "children",
                              "plural": true,
                              "selections": [
                                (v28/*: any*/),
                                (v23/*: any*/),
                                {
                                  "alias": null,
                                  "args": null,
                                  "concreteType": "FormFieldThemeOption",
                                  "kind": "LinkedField",
                                  "name": "children",
                                  "plural": true,
                                  "selections": [
                                    (v28/*: any*/),
                                    (v23/*: any*/),
                                    {
                                      "alias": null,
                                      "args": null,
                                      "concreteType": "FormFieldThemeOption",
                                      "kind": "LinkedField",
                                      "name": "children",
                                      "plural": true,
                                      "selections": [
                                        (v28/*: any*/),
                                        (v23/*: any*/),
                                        {
                                          "alias": null,
                                          "args": null,
                                          "concreteType": "FormFieldThemeOption",
                                          "kind": "LinkedField",
                                          "name": "children",
                                          "plural": true,
                                          "selections": [
                                            (v28/*: any*/),
                                            (v23/*: any*/),
                                            {
                                              "alias": null,
                                              "args": null,
                                              "concreteType": "FormFieldThemeOption",
                                              "kind": "LinkedField",
                                              "name": "children",
                                              "plural": true,
                                              "selections": [
                                                (v28/*: any*/),
                                                (v23/*: any*/),
                                                {
                                                  "alias": null,
                                                  "args": null,
                                                  "concreteType": "FormFieldThemeOption",
                                                  "kind": "LinkedField",
                                                  "name": "children",
                                                  "plural": true,
                                                  "selections": [
                                                    (v28/*: any*/),
                                                    (v23/*: any*/),
                                                    {
                                                      "alias": null,
                                                      "args": null,
                                                      "concreteType": "FormFieldThemeOption",
                                                      "kind": "LinkedField",
                                                      "name": "children",
                                                      "plural": true,
                                                      "selections": [
                                                        (v28/*: any*/),
                                                        (v23/*: any*/),
                                                        (v5/*: any*/)
                                                      ],
                                                      "storageKey": null
                                                    },
                                                    (v5/*: any*/)
                                                  ],
                                                  "storageKey": null
                                                },
                                                (v5/*: any*/)
                                              ],
                                              "storageKey": null
                                            },
                                            (v5/*: any*/)
                                          ],
                                          "storageKey": null
                                        },
                                        (v5/*: any*/)
                                      ],
                                      "storageKey": null
                                    },
                                    (v5/*: any*/)
                                  ],
                                  "storageKey": null
                                },
                                (v5/*: any*/)
                              ],
                              "storageKey": null
                            },
                            (v5/*: any*/)
                          ],
                          "storageKey": null
                        },
                        (v5/*: any*/)
                      ],
                      "storageKey": null
                    },
                    (v5/*: any*/)
                  ],
                  "storageKey": null
                },
                (v5/*: any*/)
              ],
              "storageKey": null
            }
          ],
          "type": "FormFieldThemes",
          "abstractKey": null
        },
        (v5/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "type": "AnswerThemes",
  "abstractKey": null
},
v31 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "eventIds",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "formField",
      "plural": false,
      "selections": [
        (v13/*: any*/),
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "Event",
              "kind": "LinkedField",
              "name": "options",
              "plural": true,
              "selections": [
                (v5/*: any*/),
                {
                  "alias": "name",
                  "args": null,
                  "kind": "ScalarField",
                  "name": "title",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "type": "FormFieldEvents",
          "abstractKey": null
        },
        (v5/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "type": "AnswerEvents",
  "abstractKey": null
},
v32 = {
  "kind": "InlineFragment",
  "selections": (v16/*: any*/),
  "type": "AnswerEmailWithConsents",
  "abstractKey": null
},
v33 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "individualSummary",
      "storageKey": null
    }
  ],
  "type": "AnswerOralInterview",
  "abstractKey": null
},
v34 = {
  "alias": null,
  "args": null,
  "concreteType": null,
  "kind": "LinkedField",
  "name": "formField",
  "plural": false,
  "selections": [
    (v13/*: any*/),
    (v28/*: any*/),
    (v5/*: any*/)
  ],
  "storageKey": null
},
v35 = {
  "kind": "InlineFragment",
  "selections": [
    (v34/*: any*/)
  ],
  "type": "AnswerPresentationTitle",
  "abstractKey": null
},
v36 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "balance",
  "storageKey": null
},
v37 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "slug",
  "storageKey": null
},
v38 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "avatarUrl",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "statusName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isAdmin",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "additionalViewerFields",
      "storageKey": null
    }
  ],
  "type": "Viewer",
  "abstractKey": "__isViewer"
},
v39 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "totalCommentsCount",
  "storageKey": null
},
v40 = [
  {
    "kind": "Variable",
    "name": "after",
    "variableName": "commentsCursor"
  },
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "commentsCount"
  }
],
v41 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "createdAt",
  "storageKey": null
},
v42 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "commentsCount",
  "storageKey": null
},
v43 = {
  "alias": null,
  "args": null,
  "concreteType": "Author",
  "kind": "LinkedField",
  "name": "author",
  "plural": false,
  "selections": [
    (v13/*: any*/),
    (v12/*: any*/),
    (v5/*: any*/),
    (v38/*: any*/)
  ],
  "storageKey": null
},
v44 = {
  "alias": null,
  "args": null,
  "concreteType": "CommentAuthorizations",
  "kind": "LinkedField",
  "name": "authorizations",
  "plural": false,
  "selections": [
    (v10/*: any*/),
    (v11/*: any*/),
    (v9/*: any*/),
    (v7/*: any*/),
    (v8/*: any*/),
    (v5/*: any*/)
  ],
  "storageKey": null
},
v45 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 2147483647
  }
],
v46 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "votesDownAuthorized",
  "storageKey": null
},
v47 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "submitVote",
  "storageKey": null
},
v48 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "currentViewerVote",
  "storageKey": null
},
v49 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "singleVoteMode",
  "storageKey": null
},
v50 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "votesMode",
  "storageKey": null
},
v51 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "up",
  "storageKey": null
},
v52 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "down",
  "storageKey": null
},
v53 = {
  "alias": null,
  "args": null,
  "concreteType": "Votes",
  "kind": "LinkedField",
  "name": "votes",
  "plural": false,
  "selections": [
    (v5/*: any*/),
    (v51/*: any*/),
    (v52/*: any*/)
  ],
  "storageKey": null
},
v54 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "remainingVotesCount",
  "storageKey": null
},
v55 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "limitedVotesPerUser",
  "storageKey": null
},
v56 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "authorizations",
      "plural": false,
      "selections": [
        (v13/*: any*/),
        (v46/*: any*/),
        (v47/*: any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": null,
          "kind": "LinkedField",
          "name": "unauthorizedMessages",
          "plural": false,
          "selections": [
            (v13/*: any*/),
            (v47/*: any*/),
            (v5/*: any*/)
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    (v48/*: any*/),
    (v49/*: any*/),
    (v50/*: any*/),
    (v53/*: any*/),
    (v54/*: any*/),
    (v55/*: any*/)
  ],
  "type": "Votable",
  "abstractKey": "__isVotable"
},
v57 = {
  "kind": "TypeDiscriminator",
  "abstractKey": "__isReportable"
},
v58 = {
  "alias": null,
  "args": null,
  "concreteType": null,
  "kind": "LinkedField",
  "name": "authorizations",
  "plural": false,
  "selections": [
    (v13/*: any*/),
    (v46/*: any*/)
  ],
  "storageKey": null
},
v59 = {
  "alias": null,
  "args": null,
  "concreteType": "Votes",
  "kind": "LinkedField",
  "name": "votes",
  "plural": false,
  "selections": [
    (v51/*: any*/),
    (v52/*: any*/),
    (v5/*: any*/)
  ],
  "storageKey": null
},
v60 = {
  "kind": "InlineFragment",
  "selections": [
    (v39/*: any*/),
    (v50/*: any*/),
    (v58/*: any*/),
    (v59/*: any*/)
  ],
  "type": "Reactable",
  "abstractKey": "__isReactable"
},
v61 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "cursor",
  "storageKey": null
},
v62 = {
  "alias": null,
  "args": null,
  "concreteType": "PageInfo",
  "kind": "LinkedField",
  "name": "pageInfo",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "endCursor",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasNextPage",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v63 = {
  "alias": null,
  "args": (v45/*: any*/),
  "filters": null,
  "handle": "connection",
  "key": "CommentsPanel_comments",
  "kind": "LinkedHandle",
  "name": "comments"
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "ContributionDetailsModalManagerQuery",
    "selections": [
      {
        "alias": "contribution",
        "args": (v3/*: any*/),
        "concreteType": "Contribution",
        "kind": "LinkedField",
        "name": "contributionById",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "ContributionDetailsModal_contribution"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v2/*: any*/),
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Operation",
    "name": "ContributionDetailsModalManagerQuery",
    "selections": [
      {
        "alias": "contribution",
        "args": (v3/*: any*/),
        "concreteType": "Contribution",
        "kind": "LinkedField",
        "name": "contributionById",
        "plural": false,
        "selections": [
          (v4/*: any*/),
          (v5/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isFeatured",
            "storageKey": null
          },
          (v6/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "ContributionAuthorizations",
            "kind": "LinkedField",
            "name": "authorizations",
            "plural": false,
            "selections": [
              (v7/*: any*/),
              (v8/*: any*/),
              (v9/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "commentsSubmissionAuthorized",
                "storageKey": null
              },
              (v5/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "editContribution",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "contributorContactAuthorized",
                "storageKey": null
              },
              (v10/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "ContributionAuthorizationsUnauthorizedMessages",
                "kind": "LinkedField",
                "name": "unauthorizedMessages",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "contributorContact",
                    "storageKey": null
                  },
                  (v5/*: any*/),
                  (v11/*: any*/)
                ],
                "storageKey": null
              },
              (v11/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "bookmarksCreationAuthorized",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Theme",
            "kind": "LinkedField",
            "name": "themes",
            "plural": true,
            "selections": [
              (v5/*: any*/),
              (v12/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "iconClass",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "primaryColor",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "primaryContrastColor",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "AnswerFormField",
            "kind": "LinkedField",
            "name": "additionalDisplayableFields",
            "plural": true,
            "selections": [
              (v5/*: any*/),
              (v4/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "answer",
                "plural": false,
                "selections": [
                  (v13/*: any*/),
                  (v14/*: any*/),
                  (v5/*: any*/),
                  (v17/*: any*/),
                  (v18/*: any*/),
                  (v19/*: any*/),
                  (v20/*: any*/),
                  (v22/*: any*/),
                  (v25/*: any*/),
                  (v26/*: any*/),
                  (v29/*: any*/),
                  (v30/*: any*/),
                  (v31/*: any*/),
                  (v32/*: any*/),
                  (v33/*: any*/),
                  (v35/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "answers",
                        "plural": true,
                        "selections": [
                          (v13/*: any*/),
                          (v5/*: any*/),
                          (v14/*: any*/),
                          (v17/*: any*/),
                          (v18/*: any*/),
                          (v19/*: any*/),
                          (v20/*: any*/),
                          (v22/*: any*/),
                          (v25/*: any*/),
                          (v26/*: any*/),
                          (v29/*: any*/),
                          (v30/*: any*/),
                          (v31/*: any*/),
                          (v32/*: any*/),
                          (v33/*: any*/),
                          (v35/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "type": "AnswerAddress",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v36/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "formField",
                        "plural": false,
                        "selections": [
                          (v13/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "unit",
                                "storageKey": null
                              }
                            ],
                            "type": "FormFieldBudget",
                            "abstractKey": null
                          },
                          (v5/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "AnswerBudgetChapter",
                        "kind": "LinkedField",
                        "name": "answers",
                        "plural": true,
                        "selections": [
                          (v5/*: any*/),
                          (v36/*: any*/),
                          (v34/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "AnswerOptionBudgetLine",
                            "kind": "LinkedField",
                            "name": "budgetLines",
                            "plural": true,
                            "selections": [
                              (v23/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "stepLabel",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "FormFieldOptionBudgetLine",
                                "kind": "LinkedField",
                                "name": "option",
                                "plural": false,
                                "selections": [
                                  (v5/*: any*/),
                                  (v12/*: any*/)
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "type": "AnswerBudget",
                    "abstractKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "publishedAt",
            "storageKey": null
          },
          (v37/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Author",
            "kind": "LinkedField",
            "name": "author",
            "plural": false,
            "selections": [
              (v12/*: any*/),
              (v5/*: any*/),
              (v38/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "ParticipativeModule",
            "kind": "LinkedField",
            "name": "participativeModule",
            "plural": false,
            "selections": [
              (v37/*: any*/),
              (v5/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "visualization",
                "plural": false,
                "selections": [
                  (v13/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "IntlMessage",
                    "kind": "LinkedField",
                    "name": "customIntlMessages",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "identifier",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "message",
                        "storageKey": null
                      },
                      (v5/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v5/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "collapseContributionsContent",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "contributionContentCollapsedHeight",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v39/*: any*/),
          {
            "alias": null,
            "args": (v40/*: any*/),
            "concreteType": "CommentConnection",
            "kind": "LinkedField",
            "name": "comments",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "CommentEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Comment",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v5/*: any*/),
                      (v4/*: any*/),
                      (v15/*: any*/),
                      (v41/*: any*/),
                      (v42/*: any*/),
                      (v6/*: any*/),
                      (v43/*: any*/),
                      (v44/*: any*/),
                      {
                        "alias": null,
                        "args": (v45/*: any*/),
                        "concreteType": "CommentConnection",
                        "kind": "LinkedField",
                        "name": "comments",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "CommentEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Comment",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                  (v5/*: any*/),
                                  (v15/*: any*/),
                                  (v41/*: any*/),
                                  (v42/*: any*/),
                                  (v6/*: any*/),
                                  (v43/*: any*/),
                                  (v44/*: any*/),
                                  {
                                    "alias": null,
                                    "args": (v45/*: any*/),
                                    "concreteType": "CommentConnection",
                                    "kind": "LinkedField",
                                    "name": "comments",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "CommentEdge",
                                        "kind": "LinkedField",
                                        "name": "edges",
                                        "plural": true,
                                        "selections": [
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "Comment",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                              (v5/*: any*/),
                                              (v15/*: any*/),
                                              (v41/*: any*/),
                                              (v42/*: any*/),
                                              (v6/*: any*/),
                                              (v43/*: any*/),
                                              (v44/*: any*/),
                                              {
                                                "alias": null,
                                                "args": (v45/*: any*/),
                                                "concreteType": "CommentConnection",
                                                "kind": "LinkedField",
                                                "name": "comments",
                                                "plural": false,
                                                "selections": [
                                                  {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "CommentEdge",
                                                    "kind": "LinkedField",
                                                    "name": "edges",
                                                    "plural": true,
                                                    "selections": [
                                                      {
                                                        "alias": null,
                                                        "args": null,
                                                        "concreteType": "Comment",
                                                        "kind": "LinkedField",
                                                        "name": "node",
                                                        "plural": false,
                                                        "selections": [
                                                          (v5/*: any*/),
                                                          (v15/*: any*/),
                                                          (v41/*: any*/),
                                                          (v42/*: any*/),
                                                          (v6/*: any*/),
                                                          (v43/*: any*/),
                                                          (v44/*: any*/),
                                                          {
                                                            "alias": null,
                                                            "args": (v45/*: any*/),
                                                            "concreteType": "CommentConnection",
                                                            "kind": "LinkedField",
                                                            "name": "comments",
                                                            "plural": false,
                                                            "selections": [
                                                              {
                                                                "alias": null,
                                                                "args": null,
                                                                "concreteType": "CommentEdge",
                                                                "kind": "LinkedField",
                                                                "name": "edges",
                                                                "plural": true,
                                                                "selections": [
                                                                  {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "concreteType": "Comment",
                                                                    "kind": "LinkedField",
                                                                    "name": "node",
                                                                    "plural": false,
                                                                    "selections": [
                                                                      (v5/*: any*/),
                                                                      (v15/*: any*/),
                                                                      (v41/*: any*/),
                                                                      (v42/*: any*/),
                                                                      (v6/*: any*/),
                                                                      (v43/*: any*/),
                                                                      (v44/*: any*/),
                                                                      {
                                                                        "alias": null,
                                                                        "args": (v45/*: any*/),
                                                                        "concreteType": "CommentConnection",
                                                                        "kind": "LinkedField",
                                                                        "name": "comments",
                                                                        "plural": false,
                                                                        "selections": [
                                                                          {
                                                                            "alias": null,
                                                                            "args": null,
                                                                            "concreteType": "CommentEdge",
                                                                            "kind": "LinkedField",
                                                                            "name": "edges",
                                                                            "plural": true,
                                                                            "selections": [
                                                                              {
                                                                                "alias": null,
                                                                                "args": null,
                                                                                "concreteType": "Comment",
                                                                                "kind": "LinkedField",
                                                                                "name": "node",
                                                                                "plural": false,
                                                                                "selections": [
                                                                                  (v5/*: any*/),
                                                                                  (v15/*: any*/),
                                                                                  (v41/*: any*/),
                                                                                  (v42/*: any*/),
                                                                                  (v6/*: any*/),
                                                                                  (v43/*: any*/),
                                                                                  (v44/*: any*/),
                                                                                  {
                                                                                    "alias": null,
                                                                                    "args": (v45/*: any*/),
                                                                                    "concreteType": "CommentConnection",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "comments",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                      {
                                                                                        "alias": null,
                                                                                        "args": null,
                                                                                        "concreteType": "CommentEdge",
                                                                                        "kind": "LinkedField",
                                                                                        "name": "edges",
                                                                                        "plural": true,
                                                                                        "selections": [
                                                                                          {
                                                                                            "alias": null,
                                                                                            "args": null,
                                                                                            "concreteType": "Comment",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "node",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                              (v5/*: any*/),
                                                                                              (v15/*: any*/),
                                                                                              (v41/*: any*/),
                                                                                              (v42/*: any*/),
                                                                                              (v6/*: any*/),
                                                                                              (v43/*: any*/),
                                                                                              (v44/*: any*/),
                                                                                              {
                                                                                                "alias": null,
                                                                                                "args": (v45/*: any*/),
                                                                                                "concreteType": "CommentConnection",
                                                                                                "kind": "LinkedField",
                                                                                                "name": "comments",
                                                                                                "plural": false,
                                                                                                "selections": [
                                                                                                  {
                                                                                                    "alias": null,
                                                                                                    "args": null,
                                                                                                    "concreteType": "CommentEdge",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "edges",
                                                                                                    "plural": true,
                                                                                                    "selections": [
                                                                                                      {
                                                                                                        "alias": null,
                                                                                                        "args": null,
                                                                                                        "concreteType": "Comment",
                                                                                                        "kind": "LinkedField",
                                                                                                        "name": "node",
                                                                                                        "plural": false,
                                                                                                        "selections": [
                                                                                                          (v5/*: any*/),
                                                                                                          (v15/*: any*/),
                                                                                                          (v41/*: any*/),
                                                                                                          (v42/*: any*/),
                                                                                                          (v6/*: any*/),
                                                                                                          (v43/*: any*/),
                                                                                                          (v44/*: any*/),
                                                                                                          {
                                                                                                            "alias": null,
                                                                                                            "args": (v45/*: any*/),
                                                                                                            "concreteType": "CommentConnection",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "comments",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                              {
                                                                                                                "alias": null,
                                                                                                                "args": null,
                                                                                                                "concreteType": "CommentEdge",
                                                                                                                "kind": "LinkedField",
                                                                                                                "name": "edges",
                                                                                                                "plural": true,
                                                                                                                "selections": [
                                                                                                                  {
                                                                                                                    "alias": null,
                                                                                                                    "args": null,
                                                                                                                    "concreteType": "Comment",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "node",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                      (v5/*: any*/),
                                                                                                                      (v15/*: any*/),
                                                                                                                      (v41/*: any*/),
                                                                                                                      (v42/*: any*/),
                                                                                                                      (v6/*: any*/),
                                                                                                                      (v43/*: any*/),
                                                                                                                      (v44/*: any*/),
                                                                                                                      {
                                                                                                                        "alias": null,
                                                                                                                        "args": (v45/*: any*/),
                                                                                                                        "concreteType": "CommentConnection",
                                                                                                                        "kind": "LinkedField",
                                                                                                                        "name": "comments",
                                                                                                                        "plural": false,
                                                                                                                        "selections": [
                                                                                                                          {
                                                                                                                            "alias": null,
                                                                                                                            "args": null,
                                                                                                                            "concreteType": "CommentEdge",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "edges",
                                                                                                                            "plural": true,
                                                                                                                            "selections": [
                                                                                                                              {
                                                                                                                                "alias": null,
                                                                                                                                "args": null,
                                                                                                                                "concreteType": "Comment",
                                                                                                                                "kind": "LinkedField",
                                                                                                                                "name": "node",
                                                                                                                                "plural": false,
                                                                                                                                "selections": [
                                                                                                                                  (v5/*: any*/),
                                                                                                                                  (v15/*: any*/),
                                                                                                                                  (v41/*: any*/),
                                                                                                                                  (v42/*: any*/),
                                                                                                                                  (v6/*: any*/),
                                                                                                                                  (v43/*: any*/),
                                                                                                                                  (v44/*: any*/),
                                                                                                                                  (v13/*: any*/),
                                                                                                                                  (v56/*: any*/),
                                                                                                                                  (v57/*: any*/),
                                                                                                                                  (v60/*: any*/)
                                                                                                                                ],
                                                                                                                                "storageKey": null
                                                                                                                              },
                                                                                                                              (v61/*: any*/)
                                                                                                                            ],
                                                                                                                            "storageKey": null
                                                                                                                          },
                                                                                                                          (v62/*: any*/)
                                                                                                                        ],
                                                                                                                        "storageKey": "comments(first:2147483647)"
                                                                                                                      },
                                                                                                                      (v63/*: any*/),
                                                                                                                      (v13/*: any*/),
                                                                                                                      (v56/*: any*/),
                                                                                                                      (v57/*: any*/),
                                                                                                                      (v60/*: any*/)
                                                                                                                    ],
                                                                                                                    "storageKey": null
                                                                                                                  },
                                                                                                                  (v61/*: any*/)
                                                                                                                ],
                                                                                                                "storageKey": null
                                                                                                              },
                                                                                                              (v62/*: any*/)
                                                                                                            ],
                                                                                                            "storageKey": "comments(first:2147483647)"
                                                                                                          },
                                                                                                          (v63/*: any*/),
                                                                                                          (v13/*: any*/),
                                                                                                          (v56/*: any*/),
                                                                                                          (v57/*: any*/),
                                                                                                          (v60/*: any*/)
                                                                                                        ],
                                                                                                        "storageKey": null
                                                                                                      },
                                                                                                      (v61/*: any*/)
                                                                                                    ],
                                                                                                    "storageKey": null
                                                                                                  },
                                                                                                  (v62/*: any*/)
                                                                                                ],
                                                                                                "storageKey": "comments(first:2147483647)"
                                                                                              },
                                                                                              (v63/*: any*/),
                                                                                              (v13/*: any*/),
                                                                                              (v56/*: any*/),
                                                                                              (v57/*: any*/),
                                                                                              (v60/*: any*/)
                                                                                            ],
                                                                                            "storageKey": null
                                                                                          },
                                                                                          (v61/*: any*/)
                                                                                        ],
                                                                                        "storageKey": null
                                                                                      },
                                                                                      (v62/*: any*/)
                                                                                    ],
                                                                                    "storageKey": "comments(first:2147483647)"
                                                                                  },
                                                                                  (v63/*: any*/),
                                                                                  (v13/*: any*/),
                                                                                  (v56/*: any*/),
                                                                                  (v57/*: any*/),
                                                                                  (v60/*: any*/)
                                                                                ],
                                                                                "storageKey": null
                                                                              },
                                                                              (v61/*: any*/)
                                                                            ],
                                                                            "storageKey": null
                                                                          },
                                                                          (v62/*: any*/)
                                                                        ],
                                                                        "storageKey": "comments(first:2147483647)"
                                                                      },
                                                                      (v63/*: any*/),
                                                                      (v13/*: any*/),
                                                                      (v56/*: any*/),
                                                                      (v57/*: any*/),
                                                                      (v60/*: any*/)
                                                                    ],
                                                                    "storageKey": null
                                                                  },
                                                                  (v61/*: any*/)
                                                                ],
                                                                "storageKey": null
                                                              },
                                                              (v62/*: any*/)
                                                            ],
                                                            "storageKey": "comments(first:2147483647)"
                                                          },
                                                          (v63/*: any*/),
                                                          (v13/*: any*/),
                                                          (v56/*: any*/),
                                                          (v57/*: any*/),
                                                          (v60/*: any*/)
                                                        ],
                                                        "storageKey": null
                                                      },
                                                      (v61/*: any*/)
                                                    ],
                                                    "storageKey": null
                                                  },
                                                  (v62/*: any*/)
                                                ],
                                                "storageKey": "comments(first:2147483647)"
                                              },
                                              (v63/*: any*/),
                                              (v13/*: any*/),
                                              (v56/*: any*/),
                                              (v57/*: any*/),
                                              (v60/*: any*/)
                                            ],
                                            "storageKey": null
                                          },
                                          (v61/*: any*/)
                                        ],
                                        "storageKey": null
                                      },
                                      (v62/*: any*/)
                                    ],
                                    "storageKey": "comments(first:2147483647)"
                                  },
                                  (v63/*: any*/),
                                  (v13/*: any*/),
                                  (v56/*: any*/),
                                  (v57/*: any*/),
                                  (v60/*: any*/)
                                ],
                                "storageKey": null
                              },
                              (v61/*: any*/)
                            ],
                            "storageKey": null
                          },
                          (v62/*: any*/)
                        ],
                        "storageKey": "comments(first:2147483647)"
                      },
                      (v63/*: any*/),
                      (v13/*: any*/),
                      (v56/*: any*/),
                      (v57/*: any*/),
                      (v60/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v61/*: any*/)
                ],
                "storageKey": null
              },
              (v62/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": (v40/*: any*/),
            "filters": null,
            "handle": "connection",
            "key": "CommentsPanel_comments",
            "kind": "LinkedHandle",
            "name": "comments"
          },
          (v15/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isBookmarked",
            "storageKey": null
          },
          {
            "kind": "InlineFragment",
            "selections": [
              (v50/*: any*/),
              (v58/*: any*/),
              (v59/*: any*/)
            ],
            "type": "Reactable",
            "abstractKey": "__isReactable"
          },
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "authorizations",
                "plural": false,
                "selections": [
                  (v13/*: any*/),
                  (v46/*: any*/),
                  (v47/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "unauthorizedMessages",
                    "plural": false,
                    "selections": [
                      (v13/*: any*/),
                      (v47/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              (v48/*: any*/),
              (v49/*: any*/),
              (v50/*: any*/),
              (v53/*: any*/),
              (v54/*: any*/),
              (v55/*: any*/)
            ],
            "type": "Votable",
            "abstractKey": "__isVotable"
          },
          (v57/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "6b7aab8f9f1876885d30ef6ba1b57c23",
    "id": null,
    "metadata": {},
    "name": "ContributionDetailsModalManagerQuery",
    "operationKind": "query",
    "text": "query ContributionDetailsModalManagerQuery(\n  $contributionId: ID!\n  $commentsCount: Int!\n  $commentsCursor: String\n) {\n  contribution: contributionById(contributionId: $contributionId) {\n    ...ContributionDetailsModal_contribution\n    id\n  }\n}\n\nfragment AnswerFormField_field on AnswerFormField {\n  title\n  answer {\n    __typename\n    ...AnswerPreview_answer\n    id\n  }\n}\n\nfragment AnswerPreviewAddress_answer on AnswerAddress {\n  id\n  answers {\n    __typename\n    id\n    ...ShallowAnswerPreview_answer\n  }\n}\n\nfragment AnswerPreviewBudgetDispatcher_answer on AnswerBudgetDispatcher {\n  dispatchedBudgetValues {\n    optionId\n    value\n    id\n  }\n  formField {\n    __typename\n    ... on FormFieldBudgetDispatcher {\n      maxBudgetPerOption\n      options {\n        __typename\n        id\n        name\n      }\n    }\n    id\n  }\n}\n\nfragment AnswerPreviewBudget_answer on AnswerBudget {\n  balance\n  formField {\n    __typename\n    ... on FormFieldBudget {\n      unit\n    }\n    id\n  }\n  answers {\n    id\n    balance\n    formField {\n      __typename\n      label\n      id\n    }\n    budgetLines {\n      value\n      stepLabel\n      option {\n        id\n        name\n      }\n    }\n  }\n}\n\nfragment AnswerPreviewCheckBoxes_answer on AnswerCheckBoxes {\n  formattedValues\n  other\n  otherValue\n  formField {\n    __typename\n    ... on FormFieldCheckBoxes {\n      otherFieldLabel\n    }\n    id\n  }\n}\n\nfragment AnswerPreviewEmailWithConsents_answer on AnswerEmailWithConsents {\n  content\n}\n\nfragment AnswerPreviewEvents_answer on AnswerEvents {\n  eventIds\n  formField {\n    __typename\n    ... on FormFieldEvents {\n      options {\n        id\n        name: title\n      }\n    }\n    id\n  }\n}\n\nfragment AnswerPreviewFile_answer on AnswerFile {\n  id\n  urls\n  sources {\n    id\n    name\n    url\n  }\n}\n\nfragment AnswerPreviewMatrix_answer on AnswerMatrix {\n  itemOptions {\n    item {\n      id\n    }\n    option {\n      id\n    }\n    id\n  }\n  formField {\n    __typename\n    ... on FormFieldMatrix {\n      items {\n        id\n        label\n      }\n      options {\n        __typename\n        id\n        name\n      }\n    }\n    id\n  }\n}\n\nfragment AnswerPreviewOralInterview_answer on AnswerOralInterview {\n  individualSummary\n}\n\nfragment AnswerPreviewPresentationSeparator_answer on AnswerPresentationSeparator {\n  id\n}\n\nfragment AnswerPreviewPresentationTextZone_answer on AnswerPresentationTextZone {\n  id\n}\n\nfragment AnswerPreviewPresentationTitle_answer on AnswerPresentationTitle {\n  id\n  formField {\n    __typename\n    label\n    id\n  }\n}\n\nfragment AnswerPreviewRichText_answer on AnswerRichText {\n  content\n}\n\nfragment AnswerPreviewSortableList_answer on AnswerSortableList {\n  formattedValues\n}\n\nfragment AnswerPreviewString_answer on AnswerString {\n  content\n}\n\nfragment AnswerPreviewText_answer on AnswerText {\n  content\n}\n\nfragment AnswerPreviewThemes_answer on AnswerThemes {\n  selectedThemeIds\n  formField {\n    __typename\n    ... on FormFieldThemes {\n      themes {\n        label\n        value\n        children {\n          label\n          value\n          children {\n            label\n            value\n            children {\n              label\n              value\n              children {\n                label\n                value\n                children {\n                  label\n                  value\n                  children {\n                    label\n                    value\n                    children {\n                      label\n                      value\n                      children {\n                        label\n                        value\n                        children {\n                          label\n                          value\n                          children {\n                            label\n                            value\n                            id\n                          }\n                          id\n                        }\n                        id\n                      }\n                      id\n                    }\n                    id\n                  }\n                  id\n                }\n                id\n              }\n              id\n            }\n            id\n          }\n          id\n        }\n        id\n      }\n    }\n    id\n  }\n}\n\nfragment AnswerPreview_answer on AnswerBase {\n  __isAnswerBase: __typename\n  __typename\n  ...ShallowAnswerPreview_answer\n  ...AnswerPreviewAddress_answer\n  ...AnswerPreviewBudget_answer\n}\n\nfragment CommentCard_comment on Comment {\n  id\n  content\n  createdAt\n  commentsCount\n  isFromAdminUser\n  author {\n    __typename\n    name\n    ...UserAvatar_user\n    ...UserAuthorName_user\n    id\n  }\n  authorizations {\n    requiresModeration\n    submitComment\n    commentsDisplayAuthorized\n    votesDisplayAuthorized\n    votesSubmissionAuthorized\n    id\n  }\n  ...VoteButtons_votable\n  ...Report_reportable\n  ...ReactableMeasures_reactable\n}\n\nfragment Comment_comment on Comment {\n  id\n  title\n  ...CommentCard_comment\n  isFromAdminUser\n  comments(first: 2147483647) {\n    edges {\n      node {\n        id\n        ...CommentCard_comment\n        comments(first: 2147483647) {\n          edges {\n            node {\n              id\n              ...CommentCard_comment\n              comments(first: 2147483647) {\n                edges {\n                  node {\n                    id\n                    ...CommentCard_comment\n                    comments(first: 2147483647) {\n                      edges {\n                        node {\n                          id\n                          ...CommentCard_comment\n                          comments(first: 2147483647) {\n                            edges {\n                              node {\n                                id\n                                ...CommentCard_comment\n                                comments(first: 2147483647) {\n                                  edges {\n                                    node {\n                                      id\n                                      ...CommentCard_comment\n                                      comments(first: 2147483647) {\n                                        edges {\n                                          node {\n                                            id\n                                            ...CommentCard_comment\n                                            comments(first: 2147483647) {\n                                              edges {\n                                                node {\n                                                  id\n                                                  ...CommentCard_comment\n                                                  comments(first: 2147483647) {\n                                                    edges {\n                                                      node {\n                                                        id\n                                                        ...CommentCard_comment\n                                                        __typename\n                                                      }\n                                                      cursor\n                                                    }\n                                                    pageInfo {\n                                                      endCursor\n                                                      hasNextPage\n                                                    }\n                                                  }\n                                                  __typename\n                                                }\n                                                cursor\n                                              }\n                                              pageInfo {\n                                                endCursor\n                                                hasNextPage\n                                              }\n                                            }\n                                            __typename\n                                          }\n                                          cursor\n                                        }\n                                        pageInfo {\n                                          endCursor\n                                          hasNextPage\n                                        }\n                                      }\n                                      __typename\n                                    }\n                                    cursor\n                                  }\n                                  pageInfo {\n                                    endCursor\n                                    hasNextPage\n                                  }\n                                }\n                                __typename\n                              }\n                              cursor\n                            }\n                            pageInfo {\n                              endCursor\n                              hasNextPage\n                            }\n                          }\n                          __typename\n                        }\n                        cursor\n                      }\n                      pageInfo {\n                        endCursor\n                        hasNextPage\n                      }\n                    }\n                    __typename\n                  }\n                  cursor\n                }\n                pageInfo {\n                  endCursor\n                  hasNextPage\n                }\n              }\n              __typename\n            }\n            cursor\n          }\n          pageInfo {\n            endCursor\n            hasNextPage\n          }\n        }\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n\nfragment CommentsList_comments on Comment {\n  id\n  ...Comment_comment\n}\n\nfragment ContributionBookmarkButton_contribution on Contribution {\n  id\n  isBookmarked\n  authorizations {\n    bookmarksCreationAuthorized\n    id\n  }\n}\n\nfragment ContributionCommentsPanel_contribution on Contribution {\n  id\n  title\n  totalCommentsCount\n  authorizations {\n    submitComment\n    commentsDisplayAuthorized\n    votesDisplayAuthorized\n    votesSubmissionAuthorized\n    unauthorizedMessages {\n      submitComment\n      id\n    }\n    id\n  }\n  comments(first: $commentsCount, after: $commentsCursor) {\n    edges {\n      node {\n        ...CommentsList_comments\n        id\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n  ...ReactableMeasures_reactable\n}\n\nfragment ContributionContent_contribution on Contribution {\n  content\n  participativeModule {\n    collapseContributionsContent\n    contributionContentCollapsedHeight\n    id\n  }\n}\n\nfragment ContributionDetailsModal_contribution on Contribution {\n  title\n  ...ListContribution_contribution\n}\n\nfragment ContributionHeader_contribution on Contribution {\n  id\n  title\n  publishedAt\n  slug\n  author {\n    name\n    ...UserAvatar_user\n    ...UserAuthorName_user\n    id\n  }\n  authorizations {\n    editContribution\n    contributorContactAuthorized\n    requiresModeration\n    id\n  }\n  participativeModule {\n    slug\n    id\n  }\n  ...ContributorContactButton_contribution\n  ...ContributionWithRequiredModerationBadge_contribution\n}\n\nfragment ContributionThemesLabel_themes on Theme {\n  id\n  name\n  iconClass\n  primaryColor\n  primaryContrastColor\n}\n\nfragment ContributionWithRequiredModerationBadge_contribution on Contribution {\n  authorizations {\n    requiresModeration\n    id\n  }\n}\n\nfragment ContributorContactButton_contribution on Contribution {\n  slug\n  authorizations {\n    contributorContactAuthorized\n    unauthorizedMessages {\n      contributorContact\n      id\n    }\n    id\n  }\n  participativeModule {\n    slug\n    visualization {\n      __typename\n      customIntlMessages {\n        identifier\n        message\n        id\n      }\n      id\n    }\n    id\n  }\n}\n\nfragment DownVoteButton_votable on Votable {\n  __isVotable: __typename\n  id\n  currentViewerVote\n  singleVoteMode\n  votesMode\n  authorizations {\n    __typename\n    submitVote\n    unauthorizedMessages {\n      __typename\n      submitVote\n      id\n    }\n    id\n  }\n  votes {\n    id\n    down\n  }\n  ...useVoteButtonsLabel_votable\n  ...VoteButton_votable\n}\n\nfragment ListContribution_contribution on Contribution {\n  id\n  isFeatured\n  title\n  isFromAdminUser\n  authorizations {\n    votesDisplayAuthorized\n    votesSubmissionAuthorized\n    commentsDisplayAuthorized\n    commentsSubmissionAuthorized\n    id\n  }\n  themes {\n    ...ContributionThemesLabel_themes\n    id\n  }\n  additionalDisplayableFields {\n    id\n    ...AnswerFormField_field\n  }\n  ...ContributionHeader_contribution\n  ...ContributionCommentsPanel_contribution\n  ...VoteButtons_votable\n  ...ReactableMeasures_reactable\n  ...ContributionContent_contribution\n  ...Report_reportable\n  ...ContributionBookmarkButton_contribution\n}\n\nfragment ReactableMeasures_reactable on Reactable {\n  __isReactable: __typename\n  totalCommentsCount\n  votesMode\n  authorizations {\n    __typename\n    votesDisplayAuthorized\n    votesDownAuthorized\n    commentsDisplayAuthorized\n    id\n  }\n  votes {\n    up\n    down\n    id\n  }\n}\n\nfragment Report_reportable on Reportable {\n  __isReportable: __typename\n  id\n}\n\nfragment ShallowAnswerPreview_answer on AnswerBase {\n  __isAnswerBase: __typename\n  __typename\n  ...AnswerPreviewString_answer\n  ...AnswerPreviewText_answer\n  ...AnswerPreviewRichText_answer\n  ...AnswerPreviewFile_answer\n  ...AnswerPreviewCheckBoxes_answer\n  ...AnswerPreviewBudgetDispatcher_answer\n  ...AnswerPreviewSortableList_answer\n  ...AnswerPreviewMatrix_answer\n  ...AnswerPreviewThemes_answer\n  ...AnswerPreviewEvents_answer\n  ...AnswerPreviewEmailWithConsents_answer\n  ...AnswerPreviewOralInterview_answer\n  ...AnswerPreviewPresentationSeparator_answer\n  ...AnswerPreviewPresentationTitle_answer\n  ...AnswerPreviewPresentationTextZone_answer\n}\n\nfragment UpVoteButton_votable on Votable {\n  __isVotable: __typename\n  id\n  currentViewerVote\n  singleVoteMode\n  votesMode\n  authorizations {\n    __typename\n    submitVote\n    unauthorizedMessages {\n      __typename\n      submitVote\n      id\n    }\n    id\n  }\n  votes {\n    id\n    up\n  }\n  ...useVoteButtonsLabel_votable\n  ...VoteButton_votable\n}\n\nfragment UserAuthorName_user on Viewer {\n  __isViewer: __typename\n  name\n  statusName\n  isAdmin\n  additionalViewerFields\n}\n\nfragment UserAvatar_user on Viewer {\n  __isViewer: __typename\n  name\n  avatarUrl\n}\n\nfragment VoteButton_votable on Votable {\n  __isVotable: __typename\n  remainingVotesCount\n  limitedVotesPerUser\n}\n\nfragment VoteButtons_votable on Votable {\n  __isVotable: __typename\n  authorizations {\n    __typename\n    votesSubmissionAuthorized\n    votesDownAuthorized\n    id\n  }\n  ...UpVoteButton_votable\n  ...DownVoteButton_votable\n}\n\nfragment useVoteButtonsLabel_votable on Votable {\n  __isVotable: __typename\n  votesMode\n  currentViewerVote\n  singleVoteMode\n  ...VoteButton_votable\n}\n"
  }
};
})();

node.hash = "bdd3f33580b836bd3a828661dc83c431";

module.exports = node;
